// extracted by mini-css-extract-plugin
export default {"about":"index_about_8zIMc","summary":"index_summary_4t-Yd","more":"index_more_mMnrL"};